export enum EventCandidateStatus {
  new = 0,
  pending = 1,
  selected = 2,
  completed = 3,
  canceled = 4,
  deleted = 5,
}
